(function () {
  if (!customElements.get("vertical-filter-opener")) {
    /**
     * VerticalFilterOpener
     * An accessible custom element that toggles a filter panel on desktop
     * and opens a mobile menu drawer on screens narrower than 750px.
     */
    class VerticalFilterOpener extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
      }

      connectedCallback() {
        this.filterId =
          this.getAttribute("aria-controls") || "main-collection-filters";
        this.gridId = this.getAttribute("data-grid-id") || "product-grid";
        this.openClass =
          this.getAttribute("data-open-class") || "filter-is-open";

        this.setupElements();

        if (this.verticalFilter && this.grid) {
          this.setupAccessibility();
          this.addEventListeners();
        }
      }

      setupElements() {
        this.verticalFilter = document.getElementById(this.filterId);
        this.grid = document.getElementById(this.gridId);
        // This selector is crucial for the new functionality
        this.mobileDrawer = document.querySelector("menu-drawer details");

        if (!this.verticalFilter || !this.grid) {
          console.error(
            "VerticalFilterOpener: Could not find required elements with IDs:",
            this.filterId,
            this.gridId,
          );
        }

        if (!this.mobileDrawer) {
          console.warn(
            "VerticalFilterOpener: The mobile 'menu-drawer details' element was not found.",
          );
        }
      }

      setupAccessibility() {
        if (!this.hasAttribute("role")) {
          this.setAttribute("role", "button");
        }
        if (!this.hasAttribute("tabindex")) {
          this.setAttribute("tabindex", "0");
        }
        this.setAttribute(
          "aria-expanded",
          this.verticalFilter.classList.contains(this.openClass),
        );
      }

      addEventListeners() {
        this.addEventListener("click", this.handleClick);
        this.addEventListener("keydown", this.handleKeydown);
      }

      handleClick() {
        this.toggle();
      }

      handleKeydown(event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          this.toggle();
        }
      }

      /**
       * Toggles the filter's visibility.
       */
      toggle() {
        // Check if we are on a mobile screen and if the drawer element exists
        if (window.innerWidth < 750 && this.mobileDrawer) {
          // On mobile, open the <details> element of the menu-drawer
          this.mobileDrawer.querySelector("summary").click();
          // The menu-drawer component should handle its own internal focus management
        } else {
          // On desktop, use the original behavior
          const isExpanded = this.getAttribute("aria-expanded") === "true";
          const shouldOpen = !isExpanded;

          this.verticalFilter.classList.toggle(this.openClass, shouldOpen);
          this.grid.classList.toggle(this.openClass, shouldOpen);
          this.setAttribute("aria-expanded", shouldOpen);

          if (shouldOpen) {
            const firstFocusable = this.verticalFilter.querySelector(
              '[role="tab"], button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
            );
            if (firstFocusable) {
              firstFocusable.focus();
            }
          }
        }
        // --- END: MODIFIED SECTION ---
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.handleClick);
        this.removeEventListener("keydown", this.handleKeydown);
      }
    }

    customElements.define("vertical-filter-opener", VerticalFilterOpener);
  }
})();
